import {
  GET_CUSTOMER_LIST_REQUEST,
  GET_CUSTOMER_LIST_SUCCESS,
  GET_CUSTOMER_LIST_FAILURE
} from '../constants/customerConstants';

const initialState = {
  loading: false,
  customers: [],
  totalCount: 0,
  error: null
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CUSTOMER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        customers: action.payload.response || [],
        totalCount: action.payload.pagination?.totalItems || 0
      };

    case GET_CUSTOMER_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default customerReducer;